//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'CancellationTermsView',
  components: { Section: () => import('@/components/common/Section') },
  layout: 'documentation',
  computed: {
    ...mapGetters({
      cancellation: 'terms/cancellation'
    })
  },
  mounted () {
    this.$store.dispatch('terms/fetch', {
      id: this.$route.params.entity_id,
      entity: this.$route.params.entity,
      params: {
        lang: this.$i18n.locale
      }
    })
  }
}
